import { useEffect } from 'react';

export default function useFavicon(href) {
  useEffect(() => {
    if (!href) return;

    const existingMetas = (elements) => {
      elements.forEach(element => element.remove());
    };

    const updateFavicon = () => {
      // Remove any existing favicon links
      const existingFavicons = document.querySelectorAll("link[rel*='icon']");
      existingMetas(existingFavicons);

      // Create new favicon link
      const favicon = document.createElement('link');
      favicon.rel = 'icon';
      // Append cache buster to force browser tab to reload icon
      favicon.href = `${href}?v=3`;
      favicon.type = href.endsWith('.svg') ? 'image/svg+xml' : (href.endsWith('.webp') ? 'image/webp' : 'image/png');
      favicon.setAttribute('sizes', '192x192 180x180 96x96 32x32 16x16');
      document.head.appendChild(favicon);

      // Handle apple-touch-icon and webmanifest specifically for folders containing -favicon
      const faviconDirMatch = href.match(/([^/]+-favicon)/);
      if (faviconDirMatch) {
        const faviconDir = `/${faviconDirMatch[1]}`;
        // Remove existing apple-touch-icons
        const existingAppleIcons = document.querySelectorAll("link[rel='apple-touch-icon']");
        existingMetas(existingAppleIcons);

        // Add new apple-touch-icon
        const appleIcon = document.createElement('link');
        appleIcon.rel = 'apple-touch-icon';
        appleIcon.href = `${faviconDir}/apple-touch-icon.png`;
        appleIcon.setAttribute('sizes', '180x180');
        document.head.appendChild(appleIcon);

        // Remove existing manifest link
        const existingManifests = document.querySelectorAll("link[rel='manifest']");
        existingMetas(existingManifests);

        // Add new manifest link
        const manifest = document.createElement('link');
        manifest.rel = 'manifest';
        manifest.href = `${faviconDir}/site.webmanifest`;
        document.head.appendChild(manifest);
      }
    };

    updateFavicon();

    return () => {
      // Restore standard site favicon on unmount
      const existingFavicons = document.querySelectorAll("link[rel*='icon']");
      existingMetas(existingFavicons);

      const originalFavicon = document.createElement('link');
      originalFavicon.rel = 'icon';
      originalFavicon.href = '/logo-main.png?v=3';
      originalFavicon.type = 'image/png';
      document.head.appendChild(originalFavicon);

      // Restore apple-touch-icon and manifest if changed
      if (href.includes('-favicon')) {
        const existingAppleIcons = document.querySelectorAll("link[rel='apple-touch-icon']");
        existingMetas(existingAppleIcons);

        const existingManifests = document.querySelectorAll("link[rel='manifest']");
        existingMetas(existingManifests);

        const originalManifest = document.createElement('link');
        originalManifest.rel = 'manifest';
        originalManifest.href = '/manifest.json';
        document.head.appendChild(originalManifest);
      }
    };
  }, [href]);
}

